import { CorporateFormFields } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';

interface OrderingPolicyUI {
  orderPolicyId?: string;
  orderingPolicyEnabled?: boolean;
}

type orderingPolicyArgs = {
  orderPolicyId: string;
  id: string;
};

export function transformOrderingPolicyModelToUI({
  orderPolicyId,
  id,
}: orderingPolicyArgs): OrderingPolicyUI {
  if (orderPolicyId) {
    return {
      orderPolicyId,
      orderingPolicyEnabled: true,
    };
  }

  return {
    orderPolicyId: id ? `/legal/corp/order-policy/${id}` : '',
    orderingPolicyEnabled: false,
  };
}

export const transformOrderingPolicyUiToModel = (
  values: CorporateFormFields
): Partial<CorporateFormFields> => {
  const { orderingPolicyEnabled, ...rest } = values;
  const orderPolicyId = orderingPolicyEnabled ? values.orderPolicyId : '';
  return { ...rest, orderPolicyId };
};
